// assets/product-custom-property.js
import { Component } from '@theme/component';

/**
 * @typedef {object} ProductCustomPropertyRefs
 * @property {HTMLInputElement | HTMLTextAreaElement} textInput - The text input.
 * @property {HTMLElement} characterCount - The character count element.
 * @property {HTMLElement} photoPreview - The circular photo preview element.
 * @property {HTMLInputElement} photoInput - The file input for the photo upload.
 */

/**
 * A custom element that manages product custom properties
 * @extends Component<ProductCustomPropertyRefs>
 */
class ProductCustomProperty extends Component {
  handleInput() {
    this.#updateCharacterCount();
  }

  handlePhotoChange() {
    const { photoPreview, photoInput } = this.refs;
    const file = photoInput?.files?.[0];
    if (!file || !photoPreview) return;

    const reader = new FileReader();
    reader.onload = () => {
      photoPreview.style.backgroundImage = `url(${reader.result})`;
      photoPreview.classList.add('custom-property__photo-circle--filled');
    };
    reader.readAsDataURL(file);
  }

  #updateCharacterCount() {
    const { characterCount, textInput } = this.refs;
    const currentLength = textInput.value.length;
    const maxLength = textInput.maxLength;

    const template = characterCount.getAttribute('data-template');
    if (!template) return;

    const updatedText = template.replace('[current]', currentLength.toString()).replace('[max]', maxLength.toString());

    characterCount.textContent = updatedText;
  }
}

customElements.define('product-custom-property-component', ProductCustomProperty);
